import { render } from "./Home.vue?vue&type=template&id=16fa335f"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "@/assets/styles/home.scss?vue&type=style&index=0&lang=scss"
import "./Home.vue?vue&type=style&index=1&id=16fa335f&lang=css"
script.render = render

export default script